<template>
    <div class="result">
        <Header :color="false" :hideIpt="true" />
        <div class="success-page">
            <img src="@/assets/images/common/CheckCircleFill.png" class="success-icon" alt="" srcset="">

            <div class="message">
                <h2>操作成功</h2>
                <p>已提交成功！</p>
            </div>
            <van-button type="primary" class="back-btn" @click="goToHome">返回首页</van-button>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
export default {
    name: 'SuccessPage',
    components: {
        Header
    },
    data() {
        return {
            query:null,
        }
    },
    mounted(){
        this.initShare();
        this.query = this.$route.query;
        this.$dataStatistics({
            page_title: `操作成功`,
        },'访问');
    },
    methods: {
        goToHome() {
            // 替换为实际的导航逻辑
            this.$router.push('/');
        },

    },
};
</script>

<style lang="less" scoped>
.result {
    width: 100%;
    height: 100%;
}

.success-page {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: -50px;
    margin: auto;
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    text-align: center;
}

.success-icon {
    width: 65px;
    height: 65px;
}

.message h2 {
    font-size: 20px;
    color: #333333;
    margin: 0;
    margin-top: 20px;
}

.message p {
    font-size: 14px;
    color: #9F9F9F;
    margin-top: 10px;
}

.back-btn {
    margin-top: 130px;
    width: 200px;
    height: 40px;
    background: #0059A3;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    border: none;
}
</style>